// shared/src/commonMain/kotlin/com/tovtalk/data/remote/dto/ActionResponseDto.kt
package com.tovtalk.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class LikeActionData(val liked: Boolean = true)

@Serializable
data class UnlikeActionData(val unliked: Boolean = true)

@Serializable
data class SaveActionData(val saved: Boolean = true)

@Serializable
data class UnsaveActionData(val unsaved: Boolean = true)

@Serializable
data class ViewActionData(@SerialName("is_new_view") val isNewView: Boolean = false)

@Serializable
data class DeleteActionData(val deleted: Boolean = true)
